import * as React from 'react';
import {View} from 'react-native';

import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {
  ELIGIBLE_ACCELERATOR_FALLBACK_TITLE,
  ELIGIBLE_THROUGH_FALLBACK,
  NEW_CLIENTS_PQV_FALLBACK,
  TOTAL_BONUSES,
} from '../constants';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.eligibleAccelerator');
  const headerTitle =
    tt('title', ELIGIBLE_ACCELERATOR_FALLBACK_TITLE) ||
    ELIGIBLE_ACCELERATOR_FALLBACK_TITLE;

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading" style={styles.titleText}>
            {headerTitle}
          </Text>
        </Gutter>
      </View>
      <Gutter>
        <View style={styles.content}>
          <View style={styles.globalProgressRow}>
            <LoadingBox
              style={styles.loadingBoxGlobalProgress}
              testID="eligible-accelerator-loading-global-progress"
            />
            <LoadingBox
              style={styles.loadingBoxGlobalLabel}
              testID="eligible-accelerator-loading-global-label"
            />
          </View>

          <View style={styles.monthAndDaysRow}>
            <LoadingBox
              style={styles.loadingBoxMonth}
              testID="eligible-accelerator-loading-month"
            />
            <LoadingBox
              style={styles.loadingBoxDaysLeft}
              testID="eligible-accelerator-loading-days-left"
            />
          </View>

          <Text variant="caption" style={styles.pqvTitle}>
            {tt('newClientsWith', NEW_CLIENTS_PQV_FALLBACK)}
          </Text>

          {Array.from({length: TOTAL_BONUSES}).map((_, index) => (
            <View key={index} style={styles.tierSection}>
              <LoadingBox
                style={styles.loadingBoxTierHeader}
                testID={`eligible-accelerator-loading-tier-header-${index + 1}`}
              />
              <LoadingBox
                style={styles.loadingBoxTierSlots}
                testID={`eligible-accelerator-loading-tier-slots-${index + 1}`}
              />
            </View>
          ))}
        </View>
      </Gutter>
      <Gutter>
        <View style={styles.footerRow}>
          <Text variant="heading" style={styles.footerLabelText}>
            {tt('eligible through', ELIGIBLE_THROUGH_FALLBACK)}
          </Text>
          <LoadingBox
            style={styles.loadingBoxEligibleThrough}
            testID="eligible-accelerator-loading-eligible-through"
          />
        </View>
      </Gutter>
    </View>
  );
};
